import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },


  {
    path: 'categoria-form',
    loadChildren: () => import('./pages/categorias/categoria-form/categoria-form.module').then( m => m.CategoriaFormPageModule)
  },
  {
    path: 'categoria-editar/:id',
    loadChildren: () => import('./pages/categorias/categoria-form/categoria-form.module').then( m => m.CategoriaFormPageModule)
  },
  {
    path: 'categoria-list',
    loadChildren: () => import('./pages/categorias/categoria-list/categoria-list.module').then( m => m.CategoriaListPageModule)
  },




  {
    path: 'opcionais-form',
    loadChildren: () => import('./pages/opcionais/opcionais-form/opcionais-form.module').then( m => m.OpcionaisFormPageModule)
  },
  {
    path: 'opcionais-editar/:id',
    loadChildren: () => import('./pages/opcionais/opcionais-form/opcionais-form.module').then( m => m.OpcionaisFormPageModule)
  },
  {
    path: 'opcionais-list',
    loadChildren: () => import('./pages/opcionais/opcionais-list/opcionais-list.module').then( m => m.OpcionaisListPageModule)
  },
  {
    path: 'opcionais-list2',
    loadChildren: () => import('./pages/opcionais/opcionais-list2/opcionais-list2.module').then( m => m.OpcionaisList2PageModule)
  },




  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },



  {
    path: 'opcional-produto-list',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/opcional_produto/opcional-produto-list/opcional-produto-list.module').then( m => m.OpcionalProdutoListPageModule)
  },
  {
    path: 'opcional-produto-form',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/opcional_produto/opcional-produto-form/opcional-produto-form.module').then( m => m.OpcionalProdutoFormPageModule)
  },










  {
    path: 'produto-list2/:id',
    loadChildren: () => import('./pages/produtos/produto-list2/produto-list2.module').then( m => m.ProdutoList2PageModule)
  },
  {
    path: 'produto-preco-form',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/produto-preco/produto-preco-form/produto-preco-form.module').then( m => m.ProdutoPrecoFormPageModule)
  },
  {
    path: 'produto-preco-list/:id',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/produto-preco/produto-preco-list/produto-preco-list.module').then( m => m.ProdutoPrecoListPageModule)
  },
  {
    path: 'produto-list/:id',
    loadChildren: () => import('./pages/produtos/produto-list/produto-list.module').then( m => m.ProdutoListPageModule)
  },
  {
    path: 'produto-form/:idCat',
    loadChildren: () => import('./pages/produtos/produto-form/produto-form.module').then( m => m.ProdutoFormPageModule)
  },
  {
    path: 'produto-editar/:id',
    loadChildren: () => import('./pages/produtos/produto-form/produto-form.module').then( m => m.ProdutoFormPageModule)
  },



  {
    path: 'categoria-selecao-form-ativo',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/categoria-selecao-form-ativo/categoria-selecao-form-ativo.module').then( m => m.CategoriaSelecaoFormAtivoPageModule)
  },
  {
    path: 'categoria-selecao-form-preco',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/categoria-selecao-form-preco/categoria-selecao-form-preco.module').then( m => m.CategoriaSelecaoFormPrecoPageModule)
  },
  {
    path: 'categoria-selecao-form',
    loadChildren: () => import('./pages/categoria-selecao-form/categoria-selecao-form.module').then( m => m.CategoriaSelecaoFormPageModule)
  },





  {
    path: 'frete-list-ativo',
    loadChildren: () => import('./pages/fretes/frete-list-ativo/frete-list-ativo.module').then( m => m.FreteListAtivoPageModule)
  },
  {
    path: 'frete-list-preco',
    loadChildren: () => import('./pages/fretes/frete-list-preco/frete-list-preco.module').then( m => m.FreteListPrecoPageModule)
  },
  {
    path: 'fretes-list2',
    loadChildren: () => import('./pages/fretes/fretes-list2/fretes-list2.module').then( m => m.FretesList2PageModule)
  },





  {
    path: 'opcionalgrupo',
    loadChildren: () => import('./pages/opcionalgrupo/opcionalgrupo.module').then( m => m.OpcionalgrupoPageModule)
  },



  {
    path: 'pedido-list/:tipo',
    loadChildren: () => import('./pages/pedido/pedido-list/pedido-list.module').then( m => m.PedidoListPageModule)
  },
  {
    path: 'pedido-selecionado2/:id/:tipo',
    loadChildren: () => import('./pages/pedido/pedido-selecionado2/pedido-selecionado2.module').then( m => m.PedidoSelecionado2PageModule)
  },
  {
    path: 'selecao-tipo-pedido',
    loadChildren: () => import('./pages/pedido/selecao-tipo-pedido/selecao-tipo-pedido.module').then( m => m.SelecaoTipoPedidoPageModule)
  },

  
  {
    path: 'gerenciar-pedidos/:tipo',
    loadChildren: () => import('./pages/pedido/gerenciar-pedidos/gerenciar-pedidos.module').then( m => m.GerenciarPedidosPageModule)
  },


  {
    path: 'selecao-tipo-pedido-gerenciar',
    loadChildren: () => import('./pages/pedido/selecao-tipo-pedido/selecao-tipo-pedido-gerenciar/selecao-tipo-pedido-gerenciar.module').then( m => m.SelecaoTipoPedidoGerenciarPageModule)
  },


  {
    path: 'pedido-selecionado-gerenciar/:id/:tipo',
    loadChildren: () => import('./pages/pedido/pedido-selecionado-gerenciar/pedido-selecionado-gerenciar.module').then( m => m.PedidoSelecionadoGerenciarPageModule)
  },
  {
    path: 'configuracoes-front',
    loadChildren: () => import('./pages/configuracoes-front/configuracoes-front.module').then( m => m.ConfiguracoesFrontPageModule)
  },
  {
    path: 'esqueceu-senha',
    loadChildren: () => import('./pages/esqueceu-senha/esqueceu-senha.module').then( m => m.EsqueceuSenhaPageModule)
  },
  {
    path: 'ordenar-categoria',
    loadChildren: () => import('./pages/ordenar-categoria/ordenar-categoria.module').then( m => m.OrdenarCategoriaPageModule)
  },
  {
    path: 'ordenar-produtos/:id',
    loadChildren: () => import('./pages/ordenar-produtos/ordenar-produtos.module').then( m => m.OrdenarProdutosPageModule)
  },
  {
    path: 'selecao-categoria',
    loadChildren: () => import('./pages/selecao-categoria/selecao-categoria.module').then( m => m.SelecaoCategoriaPageModule)
  },
  {
    path: 'relatorio/:tipo',
    loadChildren: () => import('./pages/relatorio/relatorio.module').then( m => m.RelatorioPageModule)
  },
  {
    path: 'estatistica',
    loadChildren: () => import('./pages/estatistica/estatistica.module').then( m => m.EstatisticaPageModule)
  },
  {
    path: 'teste-report',
    loadChildren: () => import('./pages/teste-report/teste-report.module').then( m => m.TesteReportPageModule)
  },
  {
    path: 'selecao-relatorio',
    loadChildren: () => import('./pages/selecao-relatorio/selecao-relatorio.module').then( m => m.SelecaoRelatorioPageModule)
  },
  {
    path: 'gerar-relatorios/:data/:data2/:status/:tipo',
    loadChildren: () => import('./pages/gerar-relatorio/gerar-relatorio.module').then( m => m.GerarRelatorioPageModule)
  },
  {
    path: 'gerar-ranking/:data/:data2/:status/:tipo',
    loadChildren: () => import('./pages/gerar-ranking/gerar-ranking.module').then( m => m.GerarRankingPageModule)
  },
  {
    path: 'gerar-relatorio-produtos/:data/:data2/:status/:tipo',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/gerar-relatorio-produtos/gerar-relatorio-produtos.module').then( m => m.GerarRelatorioProdutosPageModule)
  },
  {
    path: 'temas',
    loadChildren: () => import('./pages/customizar/customizar.module').then( m => m.CustomizarPageModule)
  },
  {
    path: 'atendente',
    loadChildren: () => import('./pages/atendente/atendente.module').then( m => m.AtendentePageModule)
  },
  {
    path: 'comandamesa',
    loadChildren: () => import('./pages/comandamesa/comandamesa.module').then( m => m.ComandamesaPageModule)
  },
  {
    path: 'gerenciarcomanda',
    loadChildren: () => import('./pages/comandamesa/gerenciarcomanda/gerenciarcomanda.module').then( m => m.GerenciarcomandaPageModule)
  },

  {
    path: 'comanda-selecionada/:id',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/comandamesa/comanda-selecionada/comanda-selecionada.module').then( m => m.ComandaSelecionadaPageModule)
  },
  {
    path: 'impressao-pedido/:id/:idComanda',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/comandamesa/impressao-pedido/impressao-pedido.module').then( m => m.ImpressaoPedidoPageModule)
  },
  {
    path: 'fechamento-pedido/:idPedido',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/comandamesa/fechamento-pedido/fechamento-pedido.module').then( m => m.FechamentoPedidoPageModule)
  },
  {
    path: 'entregador-list',
    loadChildren: () => import('./pages/entregador/entregador-list/entregador-list.module').then( m => m.EntregadorListPageModule)
  },
  {
    path: 'entregador-form',
    loadChildren: () => import('./pages/entregador/entregador-form/entregador-form.module').then( m => m.EntregadorFormPageModule)
  },
  {
    path: 'submenu/:id',
    loadChildren: () => import('./pages/submenu/submenu.module').then( m => m.SubmenuPageModule)
  },
  {
    path: 'alteracao-lote/:id',
    loadChildren: () => import('./pages/produtos/alteracao-lote/alteracao-lote.module').then( m => m.AlteracaoLotePageModule)
  },
  {
    path: 'categoria-selecao-alteracao-lote/:tipo',
    loadChildren: () => import('./pages/categoria-selecao-alteracao-lote/categoria-selecao-alteracao-lote.module').then( m => m.CategoriaSelecaoAlteracaoLotePageModule)
  },
  {
    path: 'alteracao-lote2/:id',
    loadChildren: () => import('./pages/produtos/alteracao-lote2/alteracao-lote2.module').then( m => m.AlteracaoLote2PageModule)
  },
  {
    path: 'gerar-relatorio-cliente/:data/:data2/:status/:tipo',
    loadChildren: () => import('./pages/gerar-relatorio-cliente/gerar-relatorio-cliente.module').then( m => m.GerarRelatorioClientePageModule)
  },
  {
    path: 'rotas',
    loadChildren: () => import('./pages/rotas/rotas.module').then( m => m.RotasPageModule)
  },
  {
    path: 'cep-list-ativo',
    loadChildren: () => import('./pages/cep/cep-list-ativo/cep-list-ativo.module').then( m => m.CepListAtivoPageModule)
  },
  {
    path: 'cep-list',
    loadChildren: () => import('./pages/cep/cep-list/cep-list.module').then( m => m.CepListPageModule)
  },
  {
    path: 'alterar-custom/:id',
    loadChildren: () => import('./pages/categorias/alterar-custom/alterar-custom.module').then( m => m.AlterarCustomPageModule)
  },
  {
    path: 'ficha-consumidor/:id',
    loadChildren: () => import('./pages/consumidor/ficha-consumidor/ficha-consumidor.module').then( m => m.FichaConsumidorPageModule)
  },
  {
    path: 'historico-consumidor',
    loadChildren: () => import('./pages/consumidor/historico-consumidor/historico-consumidor.module').then( m => m.HistoricoConsumidorPageModule)
  },
  {
    path: 'gerar-cupom/:id',
    loadChildren: () => import('./pages/consumidor/gerar-cupom/gerar-cupom.module').then( m => m.GerarCupomPageModule)
  },
  {
    path: 'consulta-consumidor',
    loadChildren: () => import('./pages/consumidor/consulta-consumidor/consulta-consumidor.module').then( m => m.ConsultaConsumidorPageModule)
  },
  {
    path: 'dados-historico/:id',
    loadChildren: () => import('./pages/consumidor/dados-historico/dados-historico.module').then( m => m.DadosRelatorioPageModule)
  },
  {
    path: 'gerar-historico-consumidor/:data/:data2/:status/:tipo/:idCon',
    loadChildren: () => import('./pages/consumidor/gerar-historico-consumidor/gerar-historico-consumidor.module').then( m => m.GerarRelatorioConsumidorPageModule)
  },
  {
    path: 'selecao-analise',
    loadChildren: () => import('./pages/consumidor/selecao-analise/selecao-analise.module').then( m => m.SelecaoAnalisePageModule)
  },
  {
    path: 'dados-ranking',
    loadChildren: () => import('./pages/consumidor/dados-ranking/dados-ranking.module').then( m => m.DadosRankingPageModule)
  },
  {
    path: 'gerar-ranking-analise/:data/:data2/:status/:tipo',
    loadChildren: () => import('./pages/consumidor/gerar-ranking/gerar-ranking.module').then( m => m.GerarRankingPageModule)
  },
  {
    path: 'dados-ociosos',
    loadChildren: () => import('./pages/consumidor/dados-ociosos/dados-ociosos.module').then( m => m.DadosOciososPageModule)
  },
  {
    path: 'gerar-ranking-ociosos/:data/:data2/:status/:tipo',
    loadChildren: () => import('./pages/consumidor/gerar-ranking-ociosos/gerar-ranking-ociosos.module').then( m => m.GerarRankingOciososPageModule)
  },
  {
    path: 'configuracoes-frete',
    loadChildren: () => import('./pages/fretes/configuracoes-frete/configuracoes-frete.module').then( m => m.ConfiguracoesFretePageModule)
  },
  {
    path: 'fretekm',
    loadChildren: () => import('./pages/fretes/fretekm/fretekm.module').then( m => m.FretekmPageModule)
  },
  {
    path: 'motoboy',
    loadChildren: () => import('./pages/motoboy/motoboy.module').then( m => m.MotoboyPageModule)
  },
  {
    path: 'entregador',
    loadChildren: () => import('./pages/entregador/entregador.module').then( m => m.EntregadorPageModule)
  },
  {
    path: 'relatorio-entrega',
    loadChildren: () => import('./pages/fretes/relatorio-entrega/relatorio-entrega.module').then( m => m.RelatorioEntregaPageModule)
  },
  {
    path: 'gerar-relatorio-entrega/:data/:data2/:status/:entregador',
    loadChildren: () => import('./pages/gerar-relatorio-entrega/gerar-relatorio-entrega.module').then( m => m.GerarRelatorioEntregaPageModule)
  },
  {
    path: 'selecao-relatorio-entrega',
    loadChildren: () => import('./pages/selecao-relatorio-entrega/selecao-relatorio-entrega.module').then( m => m.SelecaoRelatorioEntregaPageModule)
  },
  {
    path: 'ranking-entrega',
    loadChildren: () => import('./pages/ranking-entrega/ranking-entrega.module').then( m => m.RankingEntregaPageModule)
  },
  {
    path: 'gerar-ranking-entrega/:data/:data2/:status',
    loadChildren: () => import('./pages/ranking-entrega/gerar-ranking-entrega/gerar-ranking-entrega.module').then( m => m.GerarRankingEntregaPageModule)
  },
  {
    path: 'controle-caixa',
    loadChildren: () => import('./pages/controle-caixa/controle-caixa.module').then( m => m.ControleCaixaPageModule)
  },
  {
    path: 'gerar-controle-caixa/:data/:data2/:tipo/:tipo2/:tipo3',
    loadChildren: () => import('./pages/controle-caixa/gerar-controle-caixa/gerar-controle-caixa.module').then( m => m.GerarControleCaixaPageModule)
  },
  {
    path: 'encomenda',
    loadChildren: () => import('./pages/encomenda/encomenda.module').then( m => m.EncomendaPageModule)
  },
  {
    path: 'gerenciarencomenda',
    loadChildren: () => import('./pages/gerenciarencomenda/gerenciarencomenda.module').then( m => m.GerenciarencomendaPageModule)
  },
  {
    path: 'relatorio-encomenda',
    loadChildren: () => import('./pages/relatorio-encomenda/relatorio-encomenda.module').then( m => m.RelatorioEncomendaPageModule)
  },
  {
    path: 'gerar-relatorio-encomenda/:data/:data2/:status/:tipo',
    loadChildren: () => import('./pages/gerar-relatorio-encomenda/gerar-relatorio-encomenda.module').then( m => m.GerarRelatorioEncomendaPageModule)
  },
  {
    path: 'impressoras',
    loadChildren: () => import('./pages/impressoras/impressoras.module').then( m => m.ImpressorasPageModule)
  },
  {
    path: 'opcionaisporproduto',
    loadChildren: () => import('./pages/opcionaisporproduto/opcionaisporproduto.module').then( m => m.OpcionaisporprodutoPageModule)
  },
  {
    path: 'ativacaoopccomp',
    loadChildren: () => import('./pages/ativacaoopccomp/ativacaoopccomp.module').then( m => m.AtivacaoopccompPageModule)
  },
  {
    path: 'opcgrupo-list/:id',
    loadChildren: () => import('./pages/opcgrupo-list/opcgrupo-list.module').then( m => m.OpcgrupoListPageModule)
  },
  {
    path: 'nomeopcional',
    loadChildren: () => import('./pages/nomeopcional/nomeopcional.module').then( m => m.NomeopcionalPageModule)
  },
  {
    path: 'gerenciar-estoque/:id',
    loadChildren: () => import('./pages/gerenciar-estoque/gerenciar-estoque.module').then( m => m.GerenciarEstoquePageModule)
  },
  {
    path: 'gerenciar-estoque-selecao',
    loadChildren: () => import('./pages/gerenciar-estoque-selecao/gerenciar-estoque-selecao.module').then( m => m.GerenciarEstoqueSelecaoPageModule)
  },




















];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
